;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.9";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import { init, captureRouterTransitionStart } from '@sentry/nextjs';

import { loadRuntimeConfig } from '@framework/config/runtime';

import sentryConfig from './sentry.common.config';

const getClientSideSentryConfig = async () => {
    const runtimeConfig = await loadRuntimeConfig();

    return {
        dsn: runtimeConfig.SENTRY_DSN,
        environment: runtimeConfig.SENTRY_ENVIRONMENT,
        release: runtimeConfig.VERSION
    };
};

init({
    ...sentryConfig,
    ...(await getClientSideSentryConfig())
});

export const onRouterTransitionStart = captureRouterTransitionStart;
